<template>
  <v-app id="app">
    <!--navigation-drawer-->
    <vue-snotify></vue-snotify>
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      temporary
      right
      :clipped="$vuetify.breakpoint.mdAndUp"
    >
      <NavigationDrawer />
    </v-navigation-drawer>
    <!--/navigation-drawer-->
    
    <!--app-bar-->
    <v-app-bar
      class="primary white--text"
      clipped-left
      fixed
      app
      max-width="100%"
      dark
    >
      <router-link to="/" tag="v-icon">icons8-home</router-link>
      <img src="./assets/techniquest_white_logo.png" height="60" />
      <v-spacer></v-spacer>
      <v-alert
        v-if="$vuetify.breakpoint.smAndUp && updateExists"
        type="warning"
        color="white"
        width="400"
        outlined
        class="mr-6 mt-3"
        dense
        text
      >
        <v-row align="center" class="pa-0 ma-0">
          <v-col class="pa-0 ma-0 text-left">App Update Available</v-col>
          <v-col class="pa-0 ma-0 text-right">
            <v-btn small @click="refreshApp" class="white info--text"
              >Update Now</v-btn
            >
          </v-col>
        </v-row>
      </v-alert>

      <v-icon
        v-if="$store.getters.currUser != null"
        class="white--text"
        @click="logout()"
        >icons8-exit-2</v-icon
      >
      <v-app-bar-nav-icon
        v-if="$store.getters.currUser != null"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <!--/app-bar-->
                  <ModalIdle v-if="isIdle"  />

    <!--pages-content-->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container class="py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col
            class="hidden-sm-and-down"
            :style="[
              {
                backgroundImage:
                  'url(' + require('./assets/background.png') + ')',
              },
              { backgroundPosition: 'top left' },
              { backgroundRepeat: 'repeat' },
              { backgroundAttachment: 'fixed' },
              { maxWidth: '400px' },
            ]"
          >
            <img
              src="./assets/tsc.png"
              style="position: sticky; left:68px; top: 118px;"
            />
          </v-col>
          <v-col>
            <router-view /> 
            <Footer/>
          </v-col>
        </v-row>

      </v-container>

      </v-main>
    <!--/pages-content-->

    <!--footer-->

    <!--Footer max-width="100%"/-->
    <!--/footer-->
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/page-components/NavigationDrawer.vue";
import Footer from "./components/page-components/Footer.vue";
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";
import ModalIdle from "./components/page-components/ModalIdle.vue";

export default {
  name: "App",
  components: {
    NavigationDrawer,
    Footer,
    ModalIdle,
  },
  data: () => ({
    currentUser: [],
    key: "",
    showMenu: false,
    drawer: null,
    clipped: true,
    bgImage: "./assets/background.png",
    location: ''
  }),
  watch: {
    currentUser: {
      handler: function() {
        this.$store.commit("setUser", this.currentUser);
        // console.log(
        //   "currentUser: " + JSON.stringify(this.currentUser, null, 2)
        // );
      },
      deep: true,
    },
  },
  computed: {
    isIdle(){
      var t= this;
      //console.log(t.$store.state.idleVue.isIdle + " The idle");
      return t.$store.state.idleVue.isIdle;
    }
  },
  methods: {
    readUser() {},
    logout() {
      this.$snotify.confirm("Are you sure you want to log out?", "Log out", {
        titleMaxLength: 300,
        maxOnScreen: 1,
        closeOnClick: false,
        pauseOnHover: true,
        position: SnotifyPosition.centerCenter,
        buttons: [
          //Yes
          {
            text: "Yes",
            action: (toast) => this.yesAction(toast),
            bold: false,
          },
          //No
          { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
        ],
      });
    },
    yesAction(toast) {
      this.$firebase.auth.signOut().then(() => {
        this.$router.push("/login").catch((err) => {});
        this.$store.commit("setUser", null);
      });
      this.$snotify.remove(toast.id);
    },
  },
  async created() {
  var t = this;
   this.location = window.location.pathname;
    this.$firebase.auth.onAuthStateChanged((user) => {
      if (user) {
        t.$firebase.db
          .collection("users")
          .doc(user.uid)
          .get()
          .then((doc) => {
            if (doc.exists) {
              this.key = doc.id;
              var document = doc.data();
              document.id = doc.id;
              this.currentUser = document;
              //console.log('doc exists')
            } else {
              alert("No such document!");
            }
          });
        
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.snotify-confirm {
  background-color: var(--v-primary-base) !important;

  min-width: 310px !important;
}

.snotify-confirm .snotifyToast__title {
  color: white !important;
}
.snotify-confirm .snotifyToast__body {
  color: white !important;
}
</style>
